import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from "@mui/material";

import { Formik } from "formik";

export type MarkSolutionCompletedModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (name: string, url: string) => void;
};

export const LinkSolutionToIssuesModal = (props: MarkSolutionCompletedModalProps) => {
    const { isOpen, onClose, onSubmit } = props;

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="xs">
            <DialogTitle>
                Link Solution to Issues
            </DialogTitle>
            <Formik
                initialValues={{ name: '', url: '' }}
                validate={(values) => {
                    const errors: { name?: string; url?: string } = {};
                    if (!values.name) {
                        errors.name = 'Name is required';
                    }
                    if (!values.url) {
                        errors.url = 'URL is required';
                    } else if (
                        !/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(values.url)
                    ) {
                        errors.url = 'Invalid URL format';
                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    onSubmit(values.name, values.url);
                    setSubmitting(false);
                    onClose();
                }}
            >
                {({ handleSubmit, handleChange, values, errors, touched }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogContent sx={{ paddingY: 0 }}>
                            <Typography variant="body1">
                                Linking will allow the Property Manager who submitted the issue to view the solution document that you link here
                            </Typography>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="name"
                                name="name"
                                label="Document Name"
                                value={values.name}
                                onChange={handleChange}
                                error={touched.name && Boolean(errors.name)}
                                helperText={touched.name && errors.name}
                            />
                            <TextField
                                fullWidth
                                margin="dense"
                                id="url"
                                name="url"
                                label="URL"
                                value={values.url}
                                onChange={handleChange}
                                error={touched.url && Boolean(errors.url)}
                                helperText={touched.url && errors.url}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => onClose()} variant="outlined">
                                Cancel
                            </Button>
                            <Button type="submit" color="primary" variant="contained">
                                Submit
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
};